import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import styles from "./Faq.module.css";

export function Faq() {
  const { faq } = useMaestriaContent();
  const [titleLead, titleStrong] = faq.title.split("\n");

  return (
    <section id="faq" className={`maestria-section ${styles.section}`} aria-labelledby="faq-title">
      <div className={`maestria-container ${styles.inner}`}>
        <h2 id="faq-title" className={styles.title}>
          {`${titleLead}\n`}
          <strong>{titleStrong}</strong>
        </h2>
        <div className={styles.list}>
          {faq.items.map((item) => (
            <details key={item.question} className={styles.item}>
              <summary>
                {item.question}
                {/* keyboard_arrow_down do Material, o mesmo icone do Figma */}
                <svg
                  className={styles.chevron}
                  width={24}
                  height={24}
                  viewBox="0 -960 960 960"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z" />
                </svg>
              </summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
